import { useEffect, useState } from "react";
import { theme } from "twin.macro";

import Display from "@/components/Atoms/Display";
import Banners from "@/components/Molecules/Banners";
import useAppSelector from "@/hooks/useAppSelector";
import SellWithUsBanner from "@/components/Molecules/SellWithUsBanner";

import YourMostPurchased from "@/components/SymbioticOrganisms/YourMostPurchased";
import BestSeller from "@/components/SymbioticOrganisms/BestSeller";
import CategoriesPromofit from "@/components/SymbioticOrganisms/CategoriesPromofit";
import YourLastVisits from "@/components/SymbioticOrganisms/YourLastVisits";
import CategoriesNew from "@/components/SymbioticOrganisms/CategoriesNew";
import RelatedLastThingYouSaw from "@/components/SymbioticOrganisms/RelatedLastThingYouSaw";
import CategoryPopular from "@/components/SymbioticOrganisms/CategoriesPopular";
import HubPopoular from "@/components/SymbioticOrganisms/HubsPopular";
import ExclusiveDiscount from "@/components/SymbioticOrganisms/ExclusiveDiscount";
// import BlogPostList from "@/components/Organisms/BlogPostList";
import useModalAuth from "@/hooks/useModalAuth";
import useQueryParams from "@/hooks/useQueryParams";
import { useLogout } from "@/hooks/useLogout";

import { StyledWrapperContent, StyledWrapperMain } from "./styles";
import HomeSEO from "../../../SEO/HomeSEO";
import Flowbox from "@/components/Molecules/Flowbox";
import { FLOWKEY } from "@/recourses/constants";
// import Heading from "@/components/Atoms/Heading";
import useScrollPosition from "@/hooks/useScrollPosition";

const Home = () => {
  const storeId = useAppSelector((state) => state.cart.storeId);
  const userId = useAppSelector((state) => state.user?.id);
  const { queryParams, setQueryParams } = useQueryParams();
  const nextRouteParam = Boolean(queryParams.get("next"));
  const [showGridFlowbox, setShowGridFlowbox] = useState(false);

  const { handleOpenModalAuth } = useModalAuth();
  useLogout();

  // Check if show modal auth or clear next routes
  useEffect(() => {
    if (!nextRouteParam) return;

    if (!userId) {
      handleOpenModalAuth();
      return;
    }

    setQueryParams({ next: null });
  }, [userId, nextRouteParam]);

  useScrollPosition({
    threshold: 40,
    callback: () => setShowGridFlowbox(true),
  });

  return (
    <>
      <HomeSEO url={window.location.href} />
      <StyledWrapperMain>
        <Banners storeId={storeId} />

        <StyledWrapperContent>
          <Display color={theme`colors.primaryV2.50`} tw="hidden">
            Evoluciona tus habitos
          </Display>

          <ExclusiveDiscount />

          <YourMostPurchased />

          <Flowbox
            flowKey={FLOWKEY.HOME_ONE}
            enableTimeout={false}
            tags={["pasabocas"]}
            type="homeCarousel"
            islazyLoad={false}
            cover
          />

          <CategoriesPromofit />

          <BestSeller />

          <Flowbox
            flowKey={FLOWKEY.HOME_TWO}
            enableTimeout={false}
            tags={["Panadería"]}
            type="homeCarousel"
            islazyLoad={false}
            cover
          />
          <YourLastVisits />

          <CategoriesNew />

          <RelatedLastThingYouSaw />

          <CategoryPopular />

          <HubPopoular />

          {showGridFlowbox && <Flowbox flowKey={FLOWKEY.HOME} enableTimeout={false} islazyLoad={false} />}

          {/* <BlogPostList
            title={
              <Heading type="h3" tw="ml-4">
                Nuestro Blog
              </Heading>
            }
          /> */}

          <SellWithUsBanner />
        </StyledWrapperContent>
      </StyledWrapperMain>
    </>
  );
};

export default Home;
